// extracted by mini-css-extract-plugin
var _1 = "IFrame-module__container--yiI_4";
export { _1 as "container" }
